import axiosInstance from '../helpers/axiosInstance'

export const fetchCycleCounts = async (params = {}) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts`, { params })
  return res.data
}

export const createCycleCountAssignment = async data => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts`, data)
  return res.data
}

export const fetchCycleCountFilterOptions = async warehouseId => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/filter-options`, { params: { warehouse_id: warehouseId } })
  return res.data
}

export const previewCycleCount = async data => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/preview`, data)
  return res.data
}

export const unassignCycleCounts = async ({ warehouse_id, cycle_count_ids }) => {
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/unassign`, {
    warehouse_id: parseInt(warehouse_id),
    cycle_count_ids,
  })
  return res.data
}

export const reassignCycleCounts = async ({ warehouse_id, cycle_count_ids, assigned_to_id, assigned_to_ids }) => {
  const body = { warehouse_id: parseInt(warehouse_id), cycle_count_ids }
  if (assigned_to_id != null) body.assigned_to_id = assigned_to_id
  if (assigned_to_ids != null) body.assigned_to_ids = assigned_to_ids
  const res = await axiosInstance.post(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/reassign`, body)
  return res.data
}

export const fetchCycleCountReviews = async (params = {}) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/reviews`, { params })
  return res.data
}

export const resolveCycleCount = async cycleCountId => {
  const res = await axiosInstance.put(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/${cycleCountId}/resolve`)
  return res.data
}

export const fetchUnassignedCycleCounts = async (params = {}) => {
  const res = await axiosInstance.get(`${process.env.REACT_APP_PLATFORM_URL}/api/v1/cycle-counts/unassigned`, { params })
  return res.data
}
